import type { ErrorEvent } from "@sentry/browser";

/**
 * Whether the browser's own global handler reported this, rather than our code
 * choosing to.
 *
 * Deliberate captures are the blind spot of every drop keyed on where an error
 * came from: one can legitimately carry frames from a CDN-loaded dependency and
 * none of ours, or wear a message the browser also produces on its own — a
 * rejected card confirmation is exactly that shape — so judging it on anything
 * but this would discard the reports that matter most. The noise these filters
 * target never arrives caught; nothing catches it, so the global handler is
 * always what files it.
 *
 * Absent mechanism counts as handled, keeping a drop off anything it cannot
 * positively identify as unhandled.
 */
export function isUnhandled(event: ErrorEvent): boolean {
  return (
    event.exception?.values?.some(
      (value) => value.mechanism?.handled === false
    ) ?? false
  );
}
